
import * as React from "react";
import { useState, useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Documentupload from "./documentupload";
import axios from "axios";
import { styled } from "@mui/material/styles";

const ScrollableAccordionDetails = styled(AccordionDetails)({
  maxHeight: "200px",
  overflowY: "auto",
});

export default function FormAddress({
  addressData,
  setAddressData,
  onFileUrlChange,
  addressEdit,
  studentDoc,
  setAddressFlag1,
  setAddressFlag2,
  setAddressFlag3,
  setDocumentFlag1,
  setDocumentFlag2,
  setDocumentFlag3,
  setDocumentFlag4,
  setDocumentFlag5,
  setDocumentFlag6,
  setDocumentFlag7,
  setDocumentFlag8,
  setDocumentFlag9,
  setDocumentFlag10,
  setDocumentFlag11

}) {
  const [expanded, setExpanded] = useState(false);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [filteredCities, setFilteredCities] = useState({});
  const [addressCol, setAddressCol] = useState([]);
  const [error, setError] = useState("");
  const [selectedDocuments, setSelectedDocuments] = useState([]);
 
 
  useEffect(() => {
    const getStateCity = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_JHS_DEVELOPMENT+"/city/getcitystate",
         
        );
        setStates(response.data.state || []);
        setCities(response.data.city || []);
        setAddressCol(response.data.addressCol || []);

        const addressMap = new Map();
        if (addressEdit && Array.isArray(addressEdit)) {
          addressEdit.forEach((edit) => {
            if (edit.address) {
              addressMap.set(edit.address.address_id, edit.address);
              console.log('addresses', edit.address.address_id, edit.address)
              console.log("editAddress", addressEdit)
            }
          });
        }

        // Populate initial address data based on addressCol and addressMap
        const initialAddressData = response.data.addressCol.map((col) => ({
          address_id: col.address_id || "", // Ensure address_id is not null
          address_line1: addressMap.get(col.address_id)?.address_line1 || "",
          address_line2: addressMap.get(col.address_id)?.address_line2 || "",
          state_id: addressMap.get(col.address_id)?.state_id || null,
          city_id: addressMap.get(col.address_id)?.city_id || null,
          pin_code: addressMap.get(col.address_id)?.pin_code || null,
          description: addressMap.get(col.address_id)?.description || "",
          is_current_comm_address:
            addressMap.get(col.address_id)?.is_current_comm_address || false,
        }));

        setAddressData(initialAddressData);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to fetch student data.");
      }
    };

    getStateCity();
  }, [addressEdit, setAddressData]);

  useEffect(() => {
    // Update filteredCities whenever cities or addressData change
    const updateFilteredCities = () => {
      const newFilteredCities = {};
      addressData.forEach((address, index) => {
        newFilteredCities[index] = cities.filter(
          (city) => city.state_id === address.state_id
        );
      });
      setFilteredCities(newFilteredCities);
    };

    updateFilteredCities();
  }, [cities, addressData]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleInputChange = (e, panelIndex) => {
    const { name, value, checked } = e.target;
    const updatedAddressData = [...addressData];
    let newValue = value;
 // Set specific address flag based on panelIndex
 if (panelIndex === 0) {
  setAddressFlag1(true);  // Set addressFlag1 to true when panelIndex is 0
} else if (panelIndex === 1) {
  setAddressFlag2(true);  // Set addressFlag2 to true when panelIndex is 1
} else if (panelIndex === 2) {
  setAddressFlag3(true);  // Set addressFlag3 to true when panelIndex is 2
}
    if (name === "state") {
      const filtered = cities.filter((city) => city.state_id === value);
      setFilteredCities({ ...filteredCities, [panelIndex]: filtered });
      updatedAddressData[panelIndex] = {
        ...updatedAddressData[panelIndex],
        state_id: value,
        city_id: "", // Reset city_id when state changes
      };
    } else if (name === "city") {
      updatedAddressData[panelIndex] = {
        ...updatedAddressData[panelIndex],
        city_id: value,
      };
    } else if (name === "pin_code") {
      newValue = value.replace(/\D/g, "");
      if (newValue.length > 6) {
        newValue = newValue.slice(0, 6);
      }
      updatedAddressData[panelIndex] = {
        ...updatedAddressData[panelIndex],
        pin_code: newValue,
      };
    } else {
      updatedAddressData[panelIndex] = {
        ...updatedAddressData[panelIndex],
        [name]: name === "is_current_comm_address" ? checked : value,
      };
    }

    setAddressData(updatedAddressData);
    console.log("Address Index",panelIndex);
  };

  const handleFileUrlChange = (fileUrls) => {
    setSelectedDocuments(fileUrls);
    onFileUrlChange(fileUrls);
  };

  return (
    <div>
      {addressCol.map((address, index) => (
        //Update the code
        <Accordion
        key={address.address_id}
        expanded={expanded === `panel${address.address_id}`}
        onChange={handleChange(`panel${address.address_id}`)}
        elevation={0}  // This removes the shadow
        sx={{
          border: expanded === `panel${address.address_id}` 
            ? "2.9px solid #5F9ED9" // Change border color when expanded
            :  "1px solid #0A64A2",  // Default border color #5F9ED9
          borderRadius: "4px",
          marginBottom: '4px',
          transition: "border-color 0.3s ease", // Smooth transition for border color change
        }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={address.address_id}
            id={address.address_id}
          >
            <Typography>
              {addressData[index]?.is_current_comm_address == true
                ? "Communication Address"
                : address.address_name}
            </Typography>
          </AccordionSummary>
          <ScrollableAccordionDetails>
            <Typography>
              <TextField
                value={addressData[index]?.address_line1 || ""}
                onChange={(e) => handleInputChange(e, index)}
                name="address_line1"
                size="small"
                id="standard-basic"
                label="Address Line 1:"
                variant="standard"
                style={{ width: "100%" }}
       
              />
              <TextField
                value={addressData[index]?.address_line2 || ""}
                onChange={(e) => handleInputChange(e, index)}
                name="address_line2"
                size="small"
                id="standard-basic"
                label="Address Line 2:"
                variant="standard"
                style={{ width: "100%" }}
              />
              <FormControl fullWidth sx={{ mb: 1, mt: 1, pt: 0, pb: 0 }}>
                <InputLabel id={`select-state-label-${index}`}>
                  Select State
                </InputLabel>
                <Select
                  labelId={`select-state-label-${index}`}
                  id={`select-state-${index}`}
                  value={addressData[index]?.state_id || ""}
                  onChange={(e) => handleInputChange(e, index)}
                  label="Select State"
                  name="state"
                  size="small"
                  required
                >
                  {states.map((state) => (
                    <MenuItem key={state.state_id} value={state.state_id}>
                      {state.state_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ mb: 1, pt: 0, pb: 0 }}>
                <InputLabel id={`select-city-label-${index}`}>
                  Select City
                </InputLabel>
                <Select
                  labelId={`select-city-label-${index}`}
                  id={`select-city-${index}`}
                  value={addressData[index]?.city_id || ""}
                  onChange={(e) => handleInputChange(e, index)}
                  label="Select City"
                  name="city"
                  size="small"
                  required
                  disabled={!addressData[index]?.state_id}
                >
                  {(filteredCities[index] || []).map((city) => (
                    <MenuItem key={city.city_id} value={city.city_id}>
                      {city.city_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                id={`outlined-middle-name-${index}`}
                label="Pin Code"
                fullWidth
                name="pin_code"
                value={addressData[index]?.pin_code || ""}
                onChange={(e) => handleInputChange(e, index)}
                size="small"
                sx={{ mb: 1, pt: 0, pb: 0 }}
              />
              <TextField
                id={`outlined-remarks-${index}`}
                label="Description"
                placeholder="Description"
                multiline
                rows={2}
                fullWidth
                sx={{ pt: 0, pb: 0 }}
                name="description"
                size="small"
                value={addressData[index]?.description || ""}
                onChange={(e) => handleInputChange(e, index)}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      addressData[index]?.is_current_comm_address || false
                    }
                    name="is_current_comm_address"
                    onChange={(e) => handleInputChange(e, index)}
                  />
                }
                label={
                  <Typography style={{ fontSize: "14px" }}>
                    Current Communication Address
                  </Typography>
                }
              />
            </Typography>
          </ScrollableAccordionDetails>
        </Accordion>
      ))}
      <Documentupload
        onFileUrlChange={handleFileUrlChange}
        studentDoc={studentDoc}
        setDocumentFlag1={setDocumentFlag1}
        setDocumentFlag2={setDocumentFlag2}
        setDocumentFlag3={setDocumentFlag3}
        setDocumentFlag4={setDocumentFlag4}
        setDocumentFlag5={setDocumentFlag5}
        setDocumentFlag6={setDocumentFlag6}
        setDocumentFlag7={setDocumentFlag7}
        setDocumentFlag8={setDocumentFlag8}
        setDocumentFlag9={setDocumentFlag9}
        setDocumentFlag10={setDocumentFlag10}
        setDocumentFlag11={setDocumentFlag11}
      />
    </div>
  );
}